import { render, staticRenderFns } from "./BlocoDadosCarVinculadosMonitoramentoAgricola.vue?vue&type=template&id=4145aa0a&scoped=true&lang=pug"
import script from "./BlocoDadosCarVinculadosMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoDadosCarVinculadosMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosCarVinculadosMonitoramentoAgricola.vue?vue&type=style&index=0&id=4145aa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145aa0a",
  null
  
)

export default component.exports